import { useState, useEffect } from 'react';

export default function WhatsAppButton() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Botón de WhatsApp flotante */}
      <a
        href="https://wa.me/528447098387"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform z-50 animate-pulse"
      >
        <i className="ri-whatsapp-fill text-white text-3xl"></i>
      </a>

      {/* Botón de scroll to top */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-28 right-8 w-12 h-12 bg-[#C9A86A] rounded-full flex items-center justify-center shadow-xl hover:bg-[#B8935A] transition-all z-50"
        >
          <i className="ri-arrow-up-line text-[#1A1A2E] text-xl"></i>
        </button>
      )}
    </>
  );
}